/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeAndFrequenceViewModel } from "../types/GradeAndFrequenceViewModel.ts";
import { gradeFrequenceModuleViewModelSchema } from "./gradeFrequenceModuleViewModelSchema.ts";

export const gradeAndFrequenceViewModelSchema = z.object({
  modules: z.array(z.lazy(() => gradeFrequenceModuleViewModelSchema)).nullish(),
}) as unknown as ToZod<GradeAndFrequenceViewModel>;
